import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { JiraUsersComponent } from 'src/app/user/jira-users/jira-users.component';
import { NavigationService } from './service/navigation.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  user: any
  errorCount: number;
  public jiraUsersModalRef: any;

  constructor(public navigationService: NavigationService, private modalService: NgbModal) {
    this.navigationService.errorCount$.subscribe((res) => (this.errorCount = res));
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.USER));
    if(this.user != null && typeof this.user != typeof undefined){
      this.user.photoUrl = "";
      if(this.user.picture != null && typeof this.user.picture != typeof undefined){
        this.user.photoUrl = this.user.picture.split('=')[0] + '=s512-c';
      }
    }else{
      this.user = {photoUrl:""};
    }
    
    var role = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.ROLE));
    if(role != null && typeof role != typeof undefined){
      if(role.role != null && typeof role.role != typeof undefined){
        if (role.role.toLowerCase() === 'atlassian_user_manager') {
          this.openJiraUsersModal();
        } else {
          this.fetchErrors();
        }
      }else{
        this.fetchErrors();
      }
    }else{
      this.fetchErrors();
    }
    
  }

  fetchErrors() {
    this.navigationService.getErrorCount();
  }

  openJiraUsersModal() {
    this.jiraUsersModalRef = this.modalService.open(JiraUsersComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'jira-users-modal',
      backdropClass: 'jira-users-backdrop',
    });
    this.jiraUsersModalRef.componentInstance.modalRef = this.jiraUsersModalRef;
  }
}
